import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';

const DiscussionTop = styled.div`
  width: 100%;
  display: block;
  border-bottom: 0.5px solid var(--border-primary);
  text-align: center;
  margin-bottom: var(--space-24);
  ${mobile_xl(css`
    margin: var(--space-0) var(--space-20) var(--space-20);
    width: auto;
  `)}
`;

const DesignDate = styled.h2`
  text-align: center;
  position: relative;
  top: 10px;
  margin: var(--space-0);
  display: inline-block;
  color: var(--text-secondary);
  ${Typography.body_md}
  span {
    background-color: var(--background-secondary);
    position: relative;
    padding-inline: var(--space-10);
  }
  ${mobile_xl(css`
    span {
      padding-inline: var(--space-16);
    }
  `)}
`;

export { DiscussionTop, DesignDate };
